class QrModal {
  constructor(){
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalLink = '.js-btn-qr';
    const modalWrap = '.js-qr-modal';
    const modalCover = '.js-modal-cover';
    const modalClose = '.js-qr-modal-close';
    const qr = '.js-qr';
    let qrCode;
    $(modalLink).on('click',function(e){
      e.preventDefault();
      $(qr).attr('src','');
      qrCode = $(this).data('qr');
      $(qr).attr('src',qrCode);
      $(modalCover).fadeIn();
      $(modalWrap).addClass('is-active');
    })
    $(modalClose).on('click',function(e){
      e.preventDefault();
      $(modalCover).fadeOut();
      $(modalWrap).removeClass('is-active');
    })
    
  }
}
